import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor/editor/editor.api';
// Monarch grammars for syntax highlighting; each language is a lazily loaded chunk.
import 'monaco-editor/basic-languages/monaco.contribution';
import EditorWorker from 'monaco-editor/editor/editor.worker?worker';

// Bundle Monaco instead of loading it from a CDN. Only the core editor and its worker are
// included: highlighting needs no language services (TypeScript, JSON, CSS, HTML workers).
self.MonacoEnvironment = { getWorker: () => new EditorWorker() };
loader.config({ monaco });
